import { defineStore } from 'pinia'

export const useThemeStore = defineStore('theme', {
  state: () => {
    return {
      remMultiplier: 1.25,
      currentTheme: 'gold',
      currentScheme: 'light' // light dark
    }
  },
  getters: {
    themes: () => ['red', 'teal', 'blue', 'gold'],
    baseRem: () => parseFloat(getComputedStyle(document.documentElement).fontSize),
    isDarkMode: () => document.body.classList.contains('dark')
  },
  actions: {
    selectTheme(theme) {
      document.body.classList.remove(this.currentTheme)
      this.currentTheme = theme
      document.body.classList.add(this.currentTheme)
    },
    setColorScheme(className) {
      document.body.classList.remove(this.currentScheme)
      this.currentScheme = className
      document.body.classList.add(this.currentScheme)
    },
    modifyBaseRem(delta) {
      const currentFontSize = parseFloat(getComputedStyle(document.documentElement).fontSize)
      const newFontSize = Math.min(18, Math.max(12, currentFontSize + delta)) // Minimum of 12px, maximum of 24px
      document.documentElement.style.fontSize = `${newFontSize}px`
    }
  },
  persist: true
})
